import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

let locale = process.env.VUE_APP_I18N_LOCALE || 'en'
const localeInStorage = localStorage.getItem('vendorPortalLang')
if (localeInStorage && (localeInStorage === 'en' || localeInStorage === 'es')) {
  locale = localeInStorage
}

export default new Vuetify({
  lang: {
    locales: { es },
    current: locale
  }
})
